const FrameIcon = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      data-testid="video-indication-icon"
      {...props}
    >
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M2.668 7.333a4.667 4.667 0 0 1 4.667-4.667h9.333a4.667 4.667 0 0 1 4.667 4.667v9.333a4.667 4.667 0 0 1-4.667 4.667H7.335a4.667 4.667 0 0 1-4.667-4.667V7.333Z"
      />
      <path
        fill="currentColor"
        d="M10.56 10.471a.667.667 0 0 0-1.02.565v5.8c0 .523.577.843 1.02.565l4.64-2.9a.667.667 0 0 0 0-1.13l-4.64-2.9Z"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M21.002 7.577h-18m12.821-4.864-5.89 4.795m.368-4.718L4.515 7.55m15.067-3.663-4.115 3.69"
      />
    </svg>
  );
};

export default FrameIcon;
